import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IInitializePasswordRequest } from '../../classes/initialize-password';
import {
	IPasswordValidationFields,
	PasswordValidator,
	PasswordValidationFields,
} from '../../../globals/classes/password-validator';
import { BaseComponent } from '../../../globals/classes/base.component';

@Component({
	selector: 'password-fields',
	template: require('./password-fields.component.html'),
})
export class PasswordFieldsComponent extends BaseComponent implements OnInit {
	@Input() initRequest: IInitializePasswordRequest;
	validation: IPasswordValidationFields;
	public isValid: boolean = false;

	constructor(private activeModal: NgbActiveModal) {
		super();
	}

	ngOnInit() {
		this.validation = new PasswordValidationFields();
		this.mortalize(PasswordValidator.isValidPass$).subscribe((value) => (this.isValid = value));
	}

	toggleModalDialog(): void {
		this.activeModal.close();
	}

	validatePassword(value: string) {
		this.validation = PasswordValidator.checkFields(value);
		if (!!this.initRequest.passwordConfirmNew) {
			this.validateConfirmPassword(this.initRequest.passwordConfirmNew);
		}
	}

	validateConfirmPassword(value: string) {
		this.validation = PasswordValidator.CheckPasswordConfirmation(
			value,
			this.initRequest.passwordNew
		);
	}
}
